import { Box, Button, IconButton } from "@mui/material";
import React, { useState, useEffect } from "react";
import Select from "react-select";
import { getCompany } from "../../api/crud";
import { companyData } from "../../data/conpany-data";
import CardEl from "../../Elements/CardEl";
import ModalCrudCompany from "./ModalCrudCompany";
import ModalCrudCompany2 from "./ModalCrudCompany2";

const CompanyEl = ({ hooksForm, Controller, optionsCompany }) => {
  const { register, control, watch } = hooksForm;
  // const [optionsCompany, setOptionsCompany] = useState([]);
  const [companyDetail, setCompanyDetail] = useState("");
  const [companySelected, setCompanySelected] = useState(null);
  const watchCompany = watch("company");

  const [isOpenModal, setIsOpenModal] = useState(false);

  const displayCompany = (
    <CardEl
      title={
        <>
          สถานประกอบการ <span className="text-danger">*</span>
        </>
      }
    >
      <div className="mb-3 row">
        {/* <label className="col-form-label col-sm-2 text-sm-right">ชื่อ</label> */}
        <div className="col-sm-12">
          <Controller
            required
            control={control}
            name="company"
            render={({ field: { onChange, value, ref } }) => {
              return (
                <Select
                  ref={ref}
                  options={optionsCompany}
                  value={companySelected}
                  placeholder="กรุณาพิมพ์เพื่อค้นหาสถานประกอบการ"
                  name="company"
                  onChange={(ev) => {
                    onChange(ev.value);
                    setCompanySelected(ev);
                  }}
                  noOptionsMessage={() => (
                    <div
                      className="btn btn-light"
                      onClick={() => setIsOpenModal(true)}
                    >
                      เพิ่มสถานประกอบการ
                    </div>
                  )}
                  // {...field}
                />
              );
            }}
          />

          {/* <ModalCrudCompany /> */}
        </div>
      </div>
      {companySelected ? (
        <div className="mb-3 row">
          <div className="col-sm-12">
            ที่อยู่ : {companySelected.data.address} ต.
            {companySelected.data.subdistrict} อ.
            {companySelected.data.district} จ.{companySelected.data.province}{" "}
            {companySelected.data.zip}
          </div>
        </div>
      ) : (
        ""
      )}
    </CardEl>
  );

  const displayWindowPerson = (
    <CardEl title="ผู้ประสานงาน">
      <div className="mb-3 row">
        <label className="col-form-label col-sm-2 text-sm-right">
          ชื่อ <span className="text-danger">*</span>
        </label>
        <div className="col-sm-10">
          <input
            type="text"
            required
            className="form-control"
            placeholder="ชื่อ"
            {...register("name")}
          />
        </div>
      </div>
      <div className="mb-3 row">
        <label className="col-form-label col-sm-2 text-sm-right">ตำแหน่ง</label>
        <div className="col-sm-10">
          <input
            type="text"
            className="form-control"
            placeholder="ตำแหน่ง"
            {...register("position")}
          />
        </div>
      </div>

      <div className="mb-3 row">
        <label className="col-form-label col-sm-2 text-sm-right">
          เบอร์โทร
        </label>
        <div className="col-sm-10">
          <input
            type="text"
            className="form-control"
            placeholder="เบอร์โทร"
            {...register("tel")}
          />
        </div>
      </div>

      <div className="mb-3 row">
        <label className="col-form-label col-sm-2 text-sm-right">Email</label>
        <div className="col-sm-10">
          <input
            type="email"
            className="form-control"
            placeholder="Email"
            {...register("email")}
          />
        </div>
      </div>

      <div className="mb-3 row">
        <label className="col-form-label col-sm-2 text-sm-right">
          เรียนหนังสือถึง
        </label>
        <div className="col-sm-10">
          <textarea
            type="email"
            className="form-control"
            placeholder="โปรดระบุในกรณีที่ผู้รับเอกสารไม่ใช่ผู้ประสานงาน เช่น เรียนผู้อำนวยการ ผู้จัดการผ่ายบุคคล / ถ้าเป็นผู้ประสานงาน ให้ใส่ - "
            {...register("comment", {
              required: true,
            })}
          />
        </div>
      </div>
      <input
        className="form-control d-none"
        name="waiting"
        value={companySelected?.data?.waiting}
      />
    </CardEl>
  );

  return (
    <div>
      {displayCompany}
      {displayWindowPerson}
      <ModalCrudCompany2 setIsOpen={setIsOpenModal} modalIsOpen={isOpenModal} />
    </div>
  );
};

export default CompanyEl;
